module.exports = __webpack_public_path__ + "img/canbadge-round-44mm-asa_comp_line.6fbb4ca1.png";